import { render, staticRenderFns } from "./audit-account.vue?vue&type=template&id=27337d0e&scoped=true"
import script from "./audit-account.vue?vue&type=script&lang=js"
export * from "./audit-account.vue?vue&type=script&lang=js"
import style0 from "./audit-account.vue?vue&type=style&index=0&id=27337d0e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27337d0e",
  null
  
)

export default component.exports